import { render, staticRenderFns } from "./PhoneRegister.vue?vue&type=template&id=3919545d&"
import script from "./PhoneRegister.vue?vue&type=script&lang=js&"
export * from "./PhoneRegister.vue?vue&type=script&lang=js&"
import style0 from "./PhoneRegister.vue?vue&type=style&index=0&id=3919545d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports